import {toast} from '@/common/utils/webview.js';

/**
 * @param message
 * @param isWebview
 */

let timerId;

export const showToast = (message, isWebview) => {
    if (isWebview) {
        toast('webview', message);
        return;
    }

    removeToast();

    const div = document.createElement('div');
    div.classList.add('simple_toast');
    div.textContent = message;
    document.body.append(div);
    timerId = setTimeout(() => {
        document.body.removeChild(div);
    }, 2000);
};

export function removeToast() {
    const prev = document.querySelector('.simple_toast');
    if (prev) {
        document.body.removeChild(prev);
        clearTimeout(timerId);
    }
}